import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Divider,
  Button,
  Stack,
  Grid2,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import "../../../../../Components/ModalCss/TableDataViewModal.css";
import SchemeCardApproval from "../../../../../Components/SchemeCard/SchemeCardApproval";
import RejectCommendModal from "../../GoldStakeSchemeApproval/Modal/RejectCommendModal";


const ReferralsShemeApprovalModalView = ({
  open,
  onClose,
  modalViewHeadingName,
  IsShowRejectApproveButton,
  isRejectTextShowModal,
}) => {
  console.log(IsShowRejectApproveButton, "fsfjdshfjsdk");
  const scheme = {
    userType: "User",
    title: "Diamond Referral",
    reap: "13.8grams",
    startDate: "15/11/2025",
    endDate: "15/11/2026",
  };

  const [isRejectCommendModalopen, setRejectCommendModalopen] = useState(false);

  const handleRejectCommendOpenModal = () => {
    setRejectCommendModalopen(true);
  };

  const handleRejectCommendCloseModal = () => {
    setRejectCommendModalopen(false);
  };
  const TableHeadModalData = [
    "Scheme Name",
    "Purchase Value",
    "Gold Value",
    "Purchase Date",
    "Maturity Date",
  ];
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          // maxWidth:"700px",
          borderRadius: "14px",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* Dialog Header */}
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Typography className="custom-title-text" color="white">
              {modalViewHeadingName}
            </Typography>
          </DialogTitle>
        </Box>
      </Box>

      <DialogContent>
        <Box
        // p={{ xs: 2, md: 3 }}
        >
          <Grid container spacing={2}>
            {[
              { label: "User Type", value: scheme.userType },

              { label: "Title", value: scheme.title},
              { label: "Reap", value: scheme.reap },
              { label: "Start Date", value: scheme.startDate },
              { label: "End Date", value: scheme.endDate },
            ].map((field, index) => (
              <Grid
                item
                xs={field.label === "Description" ? 12 : 6}
                sm={4}
                md={field.label === "Description" ? 8 : 4}
                key={index}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  textAlign="start"
                  sx={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  <Typography
                    variant="body1"
                    className="tabledataview-content-textheading"
                  >
                    {field.label}
                  </Typography>
                  <Typography variant="subtitle2">{field.value}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ mt: 3 }} />

          {isRejectTextShowModal && (
            <Box>
              <Typography variant="subtitle2">Reject Commend:</Typography>

              <Typography variant="body1" sx={{ color: "gray", mt: 1 }}>
                "Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the industry’s
                standard dummy text ever since the 1500s, when an unknown
                printer took a galley",
              </Typography>
            </Box>
          )}
          {/* reject comamd */}
          {/* Schemes Table */}

          {IsShowRejectApproveButton && (
            <>
              
              <Grid mt={1} sx={{ display: "flex", justifyContent: "end" }}>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    onClick={handleRejectCommendOpenModal}
                    className="reject-button"
                    sx={{
                      // backgroundColor: "#C38F51",
                      textTransform: "none",
                      color: "#F53E5C",
                      fontSize: "16px",
                      // padding: "0px 40px",
                      padding: { xs: "0px 20px", md: "0px 40px" },

                      minHeight: "40px",
                      borderRadius: "23px",
                      boxShadow: "none",
                      border: "1px solid #F53E5C",
                      background: "white 0% 0% no-repeat padding-box",
                      // "&:hover": {
                      //     backgroundColor: "#3B4056",
                      // },
                    }}
                  >
                    {/* {bannerDates?.[0]?.additional_data?.[0]?.primary_button_text || "Primary Button"} */}
                    Reject
                  </Button>
                  <Button
                    variant="outlined"
                    // onClick={() => {
                    //   customerRegisterApprove(rowTableData.customer_id);
                    // }}
                    sx={{
                      // backgroundColor: "#FFAA17",
                      border: "1px solid #1FC45B",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      fontSize: "16px",
                      padding: { xs: "0px 20px", md: "0px 40px" },
                      minHeight: "40px",
                      borderRadius: "23px",
                      // font: "normal normal normal 16px / 25px Roboto",
                      letterSpacing: "0px",
                      color: "white",
                      background: "#1FC45B",
                      // "&:hover": {
                      //     backgroundColor: "#C38F51",
                      // },
                    }}
                  >
                    {/* {bannerDates?.[0]?.additional_data?.[0]?.secondary_button_text || "Secondary Button"} */}
                    Approve
                  </Button>
                </Stack>
              </Grid>
            </>
          )}
        </Box>
      </DialogContent>
      <RejectCommendModal
        open={isRejectCommendModalopen}
        onClose={handleRejectCommendCloseModal}
        onSchemeApprovalModalClose={onClose}
      />
    </Dialog>
  );
};

export default ReferralsShemeApprovalModalView;
